import { render, staticRenderFns } from "./ListActiveDetailVa2.vue?vue&type=template&id=ecb6d10a&scoped=true&"
import script from "./ListActiveDetailVa2.vue?vue&type=script&lang=js&"
export * from "./ListActiveDetailVa2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb6d10a",
  null
  
)

export default component.exports